import React from 'react';
import { Route } from 'react-router';
import { LANGUAGE_CHANGE } from '@axa-asia/hk-shared-utils/lib/languageReducer';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import config from '../config/config';
import Layout from './components/layout/Layout';
import ContactUs from './pages/ContactUs';
import Error from './pages/Error';
import Login from './pages/Login';
import AgentSummaryReport from './pages/AgentSummaryReport';
import AgentTransactionReport from './pages/AgentTransactionReport';
import CoverNoteReport from './pages/CoverNoteReport';
import MonitoringReport from './pages/MonitoringReport';
import CreateNewQuotation from './pages/CreateNewQuotation';
import PVForm from './pages/PVForm';
import Home from './pages/Home';
import CVForm from './pages/CVForm';
import RetrieveQuotation from './pages/RetrieveQuotation';
import RetrieveCoverNote from './pages/RetrieveCoverNote';
import CreateNewCoverNote from './pages/CreateNewCoverNote';
import CoverNotePvForm from './pages/CoverNotePvForm';
import CoverNoteCvForm from './pages/CoverNoteCvForm';
import UpdatePassword from './pages/UpdatePassword';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

const appUrlPath = `/${config.appUrlPath}`;

function generateHmacSHA256(data, key) {
  return CryptoJS.HmacSHA256(data, key).toString(CryptoJS.enc.Hex);
}
export default function routes(dispatch) {
  function changeLanguage(route) {
    // relative paths will use .
    if (route.params.lang.indexOf('.') === -1) {
      dispatch({
        type: LANGUAGE_CHANGE,
        language: route.params.lang
      });
    }
  }

  const requireLogin = (nextState, replace, cb) => {
    function checkAuth() {
      axios.get(`${appUrlPath}/checkLogin`, {
        params: {}
      })
        .then((res) => {
        if (!res.data.isAuthenticated) {
          replace(`/en/${config.appUrlPath}/login`);
        } else {
          const { role, signature, SECRET_KEY } = res.data
          const generatedSignature = generateHmacSHA256(role, SECRET_KEY);
          console.log('requireLogin generatedSignature',generatedSignature,'signature', signature)
          if (generatedSignature !== signature) {
            replace(`/en/${config.appUrlPath}/login`);
          } else {
            localStorage.setItem('displayName', res.data.agentName);
            localStorage.setItem('agentCode', res.data.agentCode);
            localStorage.setItem('role', res.data.role);
          if (res.data.role === 'admin') {
            localStorage.setItem('isPV', true);
            localStorage.setItem('isCV', true);
            localStorage.setItem('isPVCoverNote', true);
            localStorage.setItem('isCVCoverNote', true);
          } else {
            localStorage.setItem('isPV', res.data.isPV);
            localStorage.setItem('isCV', res.data.isCV);
            localStorage.setItem('isPVCoverNote', res.data.isPVCoverNote);
            localStorage.setItem('isCVCoverNote', res.data.isCVCoverNote);
          }
            }

        }
        cb();
      })
      .catch(() => {
        cb();
      });
    }
    checkAuth();
  };

  const requireQuotationAccess = (nextState, replace, cb) => {
    function checkAuth() {
      axios.get(`${appUrlPath}/checkLogin`, {
        params: {}
      })
      .then((res) => {
        const { role, signature, SECRET_KEY } = res.data
        const generatedSignature = generateHmacSHA256(role, SECRET_KEY);
        console.log('requireQuotationAccess generatedSignature',generatedSignature,'signature', signature)
        if (!res.data.isAuthenticated || generatedSignature !== signature) {
          replace(`/en/${config.appUrlPath}/login`);
        } else if (res.data.role !== 'admin' && !res.data.isPV && !res.data.isCV) {
          replace(`/en/${config.appUrlPath}/home`);
        } else {
          
          localStorage.setItem('displayName', res.data.agentName);
          localStorage.setItem('agentCode', res.data.agentCode);
          localStorage.setItem('role', res.data.role);
          if (res.data.role === 'admin') {
            localStorage.setItem('isPV', true);
            localStorage.setItem('isCV', true);
            localStorage.setItem('isPVCoverNote', true);
            localStorage.setItem('isCVCoverNote', true);
          } else {
            localStorage.setItem('isPV', res.data.isPV);
            localStorage.setItem('isCV', res.data.isCV);
            localStorage.setItem('isPVCoverNote', res.data.isPVCoverNote);
            localStorage.setItem('isCVCoverNote', res.data.isCVCoverNote);
          }
        }
        cb();
      })
      .catch(() => {
        cb();
      });
    }
    checkAuth();
  };

  const requireCVQuotationAccess = (nextState, replace, cb) => {
    function checkAuth() {
      axios.get(`${appUrlPath}/checkLogin`, {
        params: {}
      })
      .then((res) => {
        const { role, signature, SECRET_KEY } = res.data
        const generatedSignature = generateHmacSHA256(role, SECRET_KEY);
        console.log('requireCVQuotationAccess generatedSignature',generatedSignature,'signature', signature)
        if (!res.data.isAuthenticated || generatedSignature !== signature) {
          replace(`/en/${config.appUrlPath}/login`);
        } else if (res.data.role !== 'admin' && !res.data.isCV) {
          replace(`/en/${config.appUrlPath}/home`);
        } else {
          localStorage.setItem('displayName', res.data.agentName);
          localStorage.setItem('agentCode', res.data.agentCode);
          localStorage.setItem('role', res.data.role);
          if (res.data.role === 'admin') {
            localStorage.setItem('isPV', true);
            localStorage.setItem('isCV', true);
            localStorage.setItem('isPVCoverNote', true);
            localStorage.setItem('isCVCoverNote', true);
          } else {
            localStorage.setItem('isPV', res.data.isPV);
            localStorage.setItem('isCV', res.data.isCV);
            localStorage.setItem('isPVCoverNote', res.data.isPVCoverNote);
            localStorage.setItem('isCVCoverNote', res.data.isCVCoverNote);
          }
        }
        cb();
      })
      .catch(() => {
        cb();
      });
    }
    checkAuth();
  };

  const requirePVQuotationAccess = (nextState, replace, cb) => {
    function checkAuth() {
      axios.get(`${appUrlPath}/checkLogin`, {
        params: {}
      })
      .then((res) => {
        const { role, signature, SECRET_KEY } = res.data
        const generatedSignature = generateHmacSHA256(role, SECRET_KEY);
        console.log('requirePVQuotationAccess generatedSignature',generatedSignature,'signature', signature)
        if (!res.data.isAuthenticated || generatedSignature !== signature) {
          replace(`/en/${config.appUrlPath}/login`);
        } else if (res.data.role !== 'admin' && !res.data.isPV) {
          replace(`/en/${config.appUrlPath}/home`);
        } else {
          localStorage.setItem('displayName', res.data.agentName);
          localStorage.setItem('agentCode', res.data.agentCode);
          localStorage.setItem('role', res.data.role);
          if (res.data.role === 'admin') {
            localStorage.setItem('isPV', true);
            localStorage.setItem('isCV', true);
            localStorage.setItem('isPVCoverNote', true);
            localStorage.setItem('isCVCoverNote', true);
          } else {
            localStorage.setItem('isPV', res.data.isPV);
            localStorage.setItem('isCV', res.data.isCV);
            localStorage.setItem('isPVCoverNote', res.data.isPVCoverNote);
            localStorage.setItem('isCVCoverNote', res.data.isCVCoverNote);
          }
        }
        cb();
      })
      .catch(() => {
        cb();
      });
    }
    checkAuth();
  };

  const requireCoverNoteAccess = (nextState, replace, cb) => {
    function checkAuth() {
      axios.get(`${appUrlPath}/checkLogin`, {
        params: {}
      })
      .then((res) => {
        const { role, signature, SECRET_KEY } = res.data
        const generatedSignature = generateHmacSHA256(role, SECRET_KEY);
        console.log('requireCoverNoteAccess generatedSignature',generatedSignature,'signature', signature)
        if (!res.data.isAuthenticated || generatedSignature !== signature) {
          replace(`/en/${config.appUrlPath}/login`);
        } else if (res.data.role !== 'admin' && !res.data.isPVCoverNote && !res.data.isCVCoverNote) {
          replace(`/en/${config.appUrlPath}/home`);
        } else {
          localStorage.setItem('displayName', res.data.agentName);
          localStorage.setItem('agentCode', res.data.agentCode);
          localStorage.setItem('role', res.data.role);
          if (res.data.role === 'admin') {
            localStorage.setItem('isPV', true);
            localStorage.setItem('isCV', true);
            localStorage.setItem('isPVCoverNote', true);
            localStorage.setItem('isCVCoverNote', true);
          } else {
            localStorage.setItem('isPV', res.data.isPV);
            localStorage.setItem('isCV', res.data.isCV);
            localStorage.setItem('isPVCoverNote', res.data.isPVCoverNote);
            localStorage.setItem('isCVCoverNote', res.data.isCVCoverNote);
          }
        }
        cb();
      })
      .catch(() => {
        cb();
      });
    }
    checkAuth();
  };

  const requireCVCoverNoteAccess = (nextState, replace, cb) => {
    function checkAuth() {
      axios.get(`${appUrlPath}/checkLogin`, {
        params: {}
      })
      .then((res) => {
        const { role, signature, SECRET_KEY } = res.data
        const generatedSignature = generateHmacSHA256(role, SECRET_KEY);
        console.log('requireCVCoverNoteAccess generatedSignature',generatedSignature,'signature', signature)
        if (!res.data.isAuthenticated || generatedSignature !== signature) {
          replace(`/en/${config.appUrlPath}/login`);
        } else if (res.data.role !== 'admin' && !res.data.isCVCoverNote) {
          replace(`/en/${config.appUrlPath}/home`);
        } else {
          localStorage.setItem('displayName', res.data.agentName);
          localStorage.setItem('agentCode', res.data.agentCode);
          localStorage.setItem('role', res.data.role);
          if (res.data.role === 'admin') {
            localStorage.setItem('isPV', true);
            localStorage.setItem('isCV', true);
            localStorage.setItem('isPVCoverNote', true);
            localStorage.setItem('isCVCoverNote', true);
          } else {
            localStorage.setItem('isPV', res.data.isPV);
            localStorage.setItem('isCV', res.data.isCV);
            localStorage.setItem('isPVCoverNote', res.data.isPVCoverNote);
            localStorage.setItem('isCVCoverNote', res.data.isCVCoverNote);
          }
        }
        cb();
      })
      .catch(() => {
        cb();
      });
    }
    checkAuth();
  };

  const requirePVCoverNoteAccess = (nextState, replace, cb) => {
    function checkAuth() {
      axios.get(`${appUrlPath}/checkLogin`, {
        params: {}
      })
      .then((res) => {
        const { role, signature, SECRET_KEY } = res.data
        const generatedSignature = generateHmacSHA256(role, SECRET_KEY);
        console.log('requirePVCoverNoteAccess generatedSignature',generatedSignature,'signature', signature)
        if (!res.data.isAuthenticated || generatedSignature !== signature) {
          replace(`/en/${config.appUrlPath}/login`);
        } else if (res.data.role !== 'admin' && !res.data.isPVCoverNote) {
          replace(`/en/${config.appUrlPath}/home`);
        } else {
          localStorage.setItem('displayName', res.data.agentName);
          localStorage.setItem('agentCode', res.data.agentCode);
          localStorage.setItem('role', res.data.role);
          if (res.data.role === 'admin') {
            localStorage.setItem('isPV', true);
            localStorage.setItem('isCV', true);
            localStorage.setItem('isPVCoverNote', true);
            localStorage.setItem('isCVCoverNote', true);
          } else {
            localStorage.setItem('isPV', res.data.isPV);
            localStorage.setItem('isCV', res.data.isCV);
            localStorage.setItem('isPVCoverNote', res.data.isPVCoverNote);
            localStorage.setItem('isCVCoverNote', res.data.isCVCoverNote);
          }
        }
        cb();
      })
      .catch(() => {
        cb();
      });
    }
    checkAuth();
  };

  const requireAdminRole = (nextState, replace, cb) => {
    if (typeof window === 'undefined' || !window.localStorage) {
      cb();
      return;
    }
    try {
      const userRole = window.localStorage.getItem('role');
      if (!userRole) {
        replace(`/en/${config.appUrlPath}/login`);
      } else if (userRole !== 'admin') {
        replace(`/en/${config.appUrlPath}/home`);
      }
    } catch (e) {
      replace(`/en/${config.appUrlPath}/login`);
    }
    cb();
  };

  return <Route path=":lang" onEnter={changeLanguage}>
    <Route path={config.appUrlPath} component={Layout} isLogin="true" >
      <Route path="login" component={Login} client allowEntry />
      <Route path="forgotPassword" component={ForgotPassword} client allowEntry />
    </Route>
    <Route path={config.appUrlPath} component={Layout} isLogin="true">
      <Route path="resetpassword" component={ResetPassword} client allowEntry />
    </Route>
    <Route path={config.appUrlPath} component={Layout} onEnter={requireLogin}>
      <Route path="home" component={Home} client allowEntry />
      <Route path="agentsummaryreport" component={AgentSummaryReport} client allowEntry />
      <Route path="agenttransreport" component={AgentTransactionReport} client allowEntry />
      <Route path="covernotereport" component={CoverNoteReport} client allowEntry />
      <Route path="monitoringreport" component={MonitoringReport} client allowEntry onEnter={requireAdminRole} />
      <Route path="contactus" component={ContactUs} client allowEntry />
      <Route path="updatePassword" component={UpdatePassword} client allowEntry />
      <Route path="error" component={Error} client />
    </Route>
    <Route path={config.appUrlPath} component={Layout} onEnter={requireQuotationAccess}>
      <Route path="createNewQuotation" component={CreateNewQuotation} client allowEntry />
      <Route path="retrievequotation" component={RetrieveQuotation} client allowEntry />
    </Route>
    <Route path={config.appUrlPath} component={Layout} onEnter={requireCVQuotationAccess}>
      <Route path="cvform" component={CVForm} client allowEntry />
    </Route>
    <Route path={config.appUrlPath} component={Layout} onEnter={requirePVQuotationAccess}>
      <Route path="pvform" component={PVForm} client allowEntry />
    </Route>
    <Route path={config.appUrlPath} component={Layout} onEnter={requireCoverNoteAccess}>
      <Route path="createNewCoverNote" component={CreateNewCoverNote} client allowEntry />
      <Route path="retrievecovernote" component={RetrieveCoverNote} client allowEntry />
    </Route>
    <Route path={config.appUrlPath} component={Layout} onEnter={requireCVCoverNoteAccess}>
      <Route path="covernotecvform" component={CoverNoteCvForm} client allowEntry />
    </Route>
    <Route path={config.appUrlPath} component={Layout} onEnter={requirePVCoverNoteAccess}>
      <Route path="covernotepvform" component={CoverNotePvForm} client allowEntry />
    </Route>

  </Route>;
}



// WEBPACK FOOTER //
// ./src/app/routes.js